<template>
  <div>
    <!--No hosts-->
    <div v-if="!game.stime1_host && !game.allSessionsCancelled">
      <div>
        <small
            v-if="!game.cancels1"
            class="has-text-success"
        >{{ game.stime1 }}</small>
        <small
            v-if="game.stime1 && game.cancels1"
            class="has-text-danger line-throught"
        >{{ game.stime1 }}</small>
        <small
            v-if="game.stime2 && !game.cancels2"
            class="has-text-success"
        > - {{ game.stime2 }}</small>
        <small
            v-if="game.stime2 && game.cancels2"
            class="has-text-danger line-throught"
        >{{ game.stime2 }}</small>
        <small
            v-if="game.stime3 && !game.cancels3"
            class="has-text-success"
        > - {{ game.stime3 }}</small>
        <small
            v-if="game.stime3 && game.cancels3"
            class="has-text-danger line-throught"
        >{{ game.stime3 }}</small>
        <small
            v-if="game.stime4 && !game.cancels4"
            class="has-text-success"
        > - {{ game.stime4 }}</small>
        <small
            v-if="game.stime4 && game.cancels4"
            class="has-text-danger line-throught"
        >{{ game.stime4 }}</small>
      </div>
    </div>
    <!--One Host-->
    <!--    <div v-if="game.stime1_host && !game.stime2_host && !game.allSessionsCancelled">
          <div>
            <small
                v-if="!game.cancels1"
                class="has-text-success"
            >{{ game.stime1 }}</small>
            <small
                v-if="game.stime1 && game.cancels1"
                class="has-text-danger line-throught"
            >{{ game.stime1 }}</small>
            <small
                v-if="game.stime2 && !game.cancels2"
                class="has-text-success"
            > - {{ game.stime2 }}</small>
            <small
                v-if="game.stime2 && game.cancels2"
                class="has-text-danger line-throught"
            >{{ game.stime2 }}</small>
            <small
                v-if="game.stime3 && !game.cancels3"
                class="has-text-success"
            > - {{ game.stime3 }}</small>
            <small
                v-if="game.stime3 && game.cancels3"
                class="has-text-danger line-throught"
            >{{ game.stime3 }}</small>
            <small
                v-if="game.stime4 && !game.cancels4"
                class="has-text-success"
            > - {{ game.stime4 }}</small>
            <small
                v-if="game.stime4 && game.cancels4"
                class="has-text-danger line-throught"
            >{{ game.stime4 }}</small>
          </div>
          <div>
            <small class="has-text-danger">{{ game.stime1_host.name }}</small>
          </div>
        </div>-->
    <!--Two hosts-->
    <!--    <div v-if="game.stime2_host && !game.stime3_host && !game.allSessionsCancelled">
          <div>
            <small
                v-if="!game.cancels1"
                class="has-text-success"
            >{{ game.stime1 }}</small>
            <small
                v-if="game.stime1 && game.cancels1"
                class="has-text-danger line-throught"
            >{{ game.stime1 }}</small>
          </div>
          <div>
            <small
                v-if="game.stime1_host"
                class="has-text-danger"
            >{{ game.stime1_host.name }}</small>
          </div>
          <div>
            <small
                v-if="game.stime2 && !game.cancels2"
                class="has-text-success"
            > - {{ game.stime2 }}</small>
            <small
                v-if="game.stime2 && game.cancels2"
                class="has-text-danger line-throught"
            >{{ game.stime2 }}</small>
            <small
                v-if="game.stime3 && !game.cancels3"
                class="has-text-success"
            > - {{ game.stime3 }}</small>
            <small
                v-if="game.stime3 && game.cancels3"
                class="has-text-danger line-throught"
            >{{ game.stime3 }}</small>
            <small
                v-if="game.stime4 && !game.cancels4"
                class="has-text-success"
            > - {{ game.stime4 }}</small>
            <small
                v-if="game.stime4 && game.cancels4"
                class="has-text-danger line-throught"
            >{{ game.stime4 }}</small>
          </div>
          <div>
            <small
                v-if="game.stime2_host"
                class="has-text-danger"
            >{{ game.stime2_host.name }}</small>
          </div>
        </div>-->
    <!--Three hosts-->
    <!--    <div v-if="game.stime3_host && !game.stime4_host && !game.allSessionsCancelled">
          <div>
            <small
                v-if="!game.cancels1"
                class="has-text-success"
            >{{ game.stime1 }}</small>
            <small
                v-if="game.stime1 && game.cancels1"
                class="has-text-danger line-throught"
            >{{ game.stime1 }}</small>
          </div>
          <div>
            <small
                v-if="game.stime1_host"
                class="has-text-danger"
            >{{ game.stime1_host.name }}</small>
          </div>
          <div>
            <small
                v-if="game.stime2 && !game.cancels2"
                class="has-text-success"
            > - {{ game.stime2 }}</small>
            <small
                v-if="game.stime2 && game.cancels2"
                class="has-text-danger line-throught"
            >{{ game.stime2 }}</small>
          </div>
          <div>
            <small
                v-if="game.stime2_host"
                class="has-text-danger"
            >{{ game.stime2_host.name }}</small>
          </div>
          <div>
            <small
                v-if="game.stime3 && !game.cancels3"
                class="has-text-success"
            > - {{ game.stime3 }}</small>
            <small
                v-if="game.stime3 && game.cancels3"
                class="has-text-danger line-throught"
            >{{ game.stime3 }}</small>
            <small
                v-if="game.stime4 && !game.cancels4"
                class="has-text-success"
            > - {{ game.stime4 }}</small>
            <small
                v-if="game.stime4 && game.cancels4"
                class="has-text-danger line-throught"
            >{{ game.stime4 }}</small>
          </div>
          <div>
            <small
                v-if="game.stime3_host"
                class="has-text-danger"
            >{{ game.stime3_host.name }}</small>
          </div>
        </div>-->
    <!--Four hosts-->
    <!--    <div v-if="game.stime4_host && !game.allSessionsCancelled">
          <div>
            <small
                v-if="!game.cancels1"
                class="has-text-success"
            >{{ game.stime1 }}</small>
            <small
                v-if="game.stime1 && game.cancels1"
                class="has-text-danger line-throught"
            >{{ game.stime1 }}</small>
          </div>
          <div>
            <small
                v-if="game.stime1_host"
                class="has-text-danger"
            >{{ game.stime1_host.name }}</small>
          </div>
          <div>
            <small
                v-if="game.stime2 && !game.cancels2"
                class="has-text-success"
            > - {{ game.stime2 }}</small>
            <small
                v-if="game.stime2 && game.cancels2"
                class="has-text-danger line-throught"
            >{{ game.stime2 }}</small>
          </div>
          <div>
            <small
                v-if="game.stime2_host"
                class="has-text-danger"
            >{{ game.stime2_host.name }}</small>
          </div>
          <div>
            <small
                v-if="game.stime3 && !game.cancels3"
                class="has-text-success"
            > - {{ game.stime3 }}</small>
            <small
                v-if="game.stime3 && game.cancels3"
                class="has-text-danger line-throught"
            >{{ game.stime3 }}</small>
          </div>
          <div>
            <small
                v-if="game.stime3_host"
                class="has-text-danger"
            >{{ game.stime3_host.name }}</small>
          </div>
          <div>
            <small
                v-if="game.stime4 && !game.cancels4"
                class="has-text-success"
            > - {{ game.stime4 }}</small>
            <small
                v-if="game.stime4 && game.cancels4"
                class="has-text-danger line-throught"
            >{{ game.stime4 }}</small>
          </div>
          <div>
            <small
                v-if="game.stime4_host"
                class="has-text-danger"
            >{{ game.stime4_host.name }}</small>
          </div>
        </div>-->

    <div v-for="(sessionArray, index) of sessionDisplay" v-if="!game.allSessionsCancelled">
      <div>
          <small
              v-for="(session, sindex) of sessionArray"
              :class="{'has-text-success': !session.cancelled, 'has-text-danger': session.cancelled, 'line-throught': session.cancelled}"
          >{{ session.time }} {{ sessionArray[sindex + 1] ? '- ' : '' }}</small>
      </div>
      <div v-if="sessionArray[0] && sessionArray[0].host && sessionArray[0].host.id !== -1">
        <small
            class="has-text-danger"
        >{{ sessionArray[0].host.name }}</small>
      </div>
    </div>

    <!-- Test -->

    <!--Game canceled and game's short note-->
    <div v-if="game.allSessionsCancelled">
      <!--All sessions canceled-->
      <p
          v-if="game.allSessionsCancelled"
          class="is-cancelled"
      >
        Cancelled
      </p>
    </div>
    <!--<div>
      <p
              class="is-cancelled"
      >
        Cancelled
      </p>
    </div>-->
    <small class="is-uppercase">{{ game.notes && cutNotes(game.notes) }}</small>
  </div>
</template>

<style scoped>
.is-cancelled {
  max-width: 150px;
  flex: 0;
  display: block;
  margin: 0 auto;
}
</style>

<script>
import Vue from 'vue';
export default {
  props: ['game'],
  data () {
    return {
      sessions: [],
      sessionDisplay: [],
    }
  },
  computed: {},
  mounted () {
    this.setSessionHosts()
    this.setSessionDisplay()
  },
  methods: {
    setSessionHosts () {
      const sessions = []
      const game = this.game;
      game.stime1 && sessions.push(
          {
            session: 1,
            time: game.stime1,
            host: game.stime1_host ? game.stime1_host : { id: -1, name: '' },
            cancelled: game.cancels1
          }
      )
      game.stime2 && sessions.push(
          {
            session: 2,
            time: game.stime2,
            host: game.stime2_host ? game.stime2_host : { id: -1, name: '' },
            cancelled: game.cancels2
          }
      )

      game.stime3 && sessions.push(
          {
            session: 3,
            time: game.stime3,
            host: game.stime3_host ? game.stime3_host : { id: -1, name: '' },
            cancelled: game.cancels3
          }
      )
      game.stime4 && sessions.push(
          {
            session: 4,
            time: game.stime4,
            host: game.stime4_host ? game.stime4_host : { id: -1, name: '' },
            cancelled: game.cancels4
          }
      )

      this.sessions = sessions
    },
    setSessionDisplay () {
      if (!this.sessions.length) return
      const result = []
      let sessionCombinedData = []
      for (let i = 0; i < this.sessions.length; i++) {
        if (this.sessions[i - 1]) {
          if (this.sessions[i - 1].host.id === this.sessions[i].host.id) {
            sessionCombinedData.push({...this.sessions[i]})
          } else if (this.sessions[i - 1].host.id !== -1 && this.sessions[i].host.id === -1) {
            sessionCombinedData.push({...this.sessions[i]})
          }
          else {
            result.push([...sessionCombinedData])
            sessionCombinedData = [{...this.sessions[i]}]

          }
        } else {
          sessionCombinedData.push({...this.sessions[i]})
        }
      }
      if (sessionCombinedData.length > 0) {
        result.push([...sessionCombinedData])
      }
      console.log(result);
      this.sessionDisplay = result;
    },
    cutNotes (string) {
      return string.split('<br>')[0]
    }
  }
}
</script>